import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { MatIconModule } from '@angular/material/icon';

import { FuseSharedModule } from '@fuse/shared.module';

import { Error403Component } from './error-403.component';
import { AuthGuardService as AuthGuard } from '@kainet/kainet-security-common-lib';  
const routes = [
    {
        path     : 'errors/error-403',
        component: Error403Component,
        canActivate: [AuthGuard],
    }
];

@NgModule({
    declarations: [
        Error403Component
    ],
    imports     : [
        RouterModule.forChild(routes),

        MatIconModule,

        FuseSharedModule
    ]
})
export class Error403Module
{
}
